import { useContext } from 'react';

import { StoredResourceTagsContext } from './StoredResourceTagsContext';

// Create a custom hook to use the context
export function useStoredResourceTags() {
  const context = useContext(StoredResourceTagsContext);
  if (context === undefined) {
    throw new Error(
      'useStoredResourceTags must be used within a StoredResourceTagsProvider'
    );
  }
  return context;
}
